module.exports = __webpack_public_path__ + "static/mystic.e3f2d7cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/mystic.jpg
// module id = 1018
// module chunks = 35783957827783